import React from 'react';
import { Grid, Card, Checkbox } from 'semantic-ui-react'
import './styles.css';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import NumberCard from './../../drive/NumberCard'
import UpgradePlan from './drive/UpgradePlan';
import { dispatch } from '@rematch/core';

class Upgrade extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
        this.upgradeSubscription = this.upgradeSubscription.bind(this);
        this.gotoDashboard = this.gotoDashboard.bind(this);

    }

    componentDidMount() {
        dispatch.app.setCurrentContext("acc-billing");

        let isDisabled = false;
        let account = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0];
        if (account.role === "user") {
            isDisabled = true;
        } else if (account.role === "customerAdmin" && !account.isActive) {
            isDisabled = true;
        }

        if (isDisabled) {
            this.props.history.push({
                pathname: `/app/${this.props.selectedAccount._id}/dashboard`
            });
        }
    }

    async upgradeSubscription(planId, subscriptionType, planDisplayName, subscriptionId) {
        const payload = {
            accountId: this.props.selectedAccount._id,
            data: {
                subscriptionId: subscriptionId,
                subscriptionType: subscriptionType,
                planId: planId,
                planDisplayName: planDisplayName
            }
        }
        await dispatch.account.upgradeAccount(payload);
        await dispatch.app.setAccountSubscriptionDetails(payload.accountId)
    }

    gotoDashboard() {
        const history = this.props.history;
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/dashboard`
        });
    }

    render() {

        const { selectedAccount, accountSubscriptionDetail } = this.props;

        return (
            <div >
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Card.Group itemsPerRow={3}>
                                <Card style={{ width: "33%", }} >
                                    <NumberCard
                                        name={
                                            <span>{selectedAccount.planDisplayName}
                                                <span className="f_10"> ( {selectedAccount.planId.includes('annual') ? "Yearly" : "Monthly"} )</span>
                                            </span>}
                                        text="Current Account Subscription " />
                                </Card>
                                <Card style={{ margin: "10px 0", width: "33%", }}>
                                    <NumberCard
                                        name={
                                            accountSubscriptionDetail && accountSubscriptionDetail.createWorkspace && accountSubscriptionDetail.createWorkspace.allowedLimit === -1 ? accountSubscriptionDetail.createWorkspace.entityCount :
                                                <div>
                                                    {accountSubscriptionDetail && accountSubscriptionDetail.createWorkspace ? accountSubscriptionDetail.createWorkspace.entityCount : 0}
                                                    <span className="f_14"> / {accountSubscriptionDetail && accountSubscriptionDetail.createWorkspace ? accountSubscriptionDetail.createWorkspace.allowedLimit : 0}</span>
                                                </div>
                                        }
                                        text="Workspaces Utilization" />
                                </Card>
                                <Card style={{ margin: "10px 0", width: "calc(33% - 35px)", }}>
                                    <NumberCard
                                        name={
                                            <div>
                                                {accountSubscriptionDetail && accountSubscriptionDetail.publishPlaybook && accountSubscriptionDetail.publishPlaybook.allowedLimit === -1 ? accountSubscriptionDetail.publishPlaybook.entityCount :
                                                    <span>
                                                        {accountSubscriptionDetail && accountSubscriptionDetail.publishPlaybook ? accountSubscriptionDetail.publishPlaybook.entityCount : 0}
                                                        <span className="f_14"> / {accountSubscriptionDetail && accountSubscriptionDetail.publishPlaybook ? accountSubscriptionDetail.publishPlaybook.allowedLimit : 0}</span>
                                                    </span>
                                                }
                                            </div>
                                        }
                                        text="Playbooks Utilization" />

                                </Card>

                            </Card.Group>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className="pad_0" >
                        <Grid.Column >
                            <div className="general-setting">
                                <Card style={{ marginBottom: "20px" }} >
                                    <Card.Header>
                                        Plans
                                        <span className="float-right">
                                            contact  <a className={`clr-blue `}  href="mailto:support@aspenify.com" target="_blank" > support@aspenify.com</a>
                                        </span>
                                    </Card.Header>
                                    <Card.Content>
                                        <UpgradePlan planId={selectedAccount.planId}
                                            subscriptionId={selectedAccount.subscriptionId}
                                            customerId={selectedAccount.customerId}
                                            currencyCode={selectedAccount.currencyCode}
                                            selectedAccount={selectedAccount}
                                        />
                                    </Card.Content>
                                </Card>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </div>

        );
    }
}

function mapStateToProps(state) {

    return {
        selectedAccount: state.app.selectedAccount,
        accountSubscriptionDetail: state.app.accountSubscriptionDetail,
        user: state.app.user
    };
}

const connectedDashboardDesignerPage = withRouter(connect(mapStateToProps)(Upgrade));
export { connectedDashboardDesignerPage as Upgrade };


